module.exports = __webpack_public_path__ + "img/DE01028.09695160.png";